import type { UserType } from "./types";

export const USER_TYPES = {
  admin: {
    value: "admin",
    label: "Admin Users",
    singular: "Admin User",
    listApi: "/users",
    detailApi: "/users/:id",
  },
  client: {
    value: "client",
    label: "Client Users",
    singular: "Client User",
    listApi: "/customers/app-users",
    detailApi: "/customers/app-users/:id",
  },
  business: {
    value: "business",
    label: "Business Users",
    singular: "Business User",
    listApi: "/customers/business-users",
    detailApi: "/customers/business-users/:id",
  },
} as const;

export type { UserType };

export const DEFAULT_USER_TYPE: UserType = "admin";

export const isValidUserType = (value?: string): value is UserType =>
  !!value && value in USER_TYPES;

export const getUserTypeLabel = (
  userType: UserType,
  options?: { singular?: boolean }
) =>
  options?.singular
    ? USER_TYPES[userType].singular
    : USER_TYPES[userType].label;

export {
  CLIENT_USERS_LIST_PATH,
  getClientUserViewPath,
  BUSINESS_USERS_LIST_PATH,
  getBusinessUserViewPath,
} from "./shared/appUserConstants";

export { ADMIN_USERS_LIST_PATH, getAdminUserViewPath } from "./admin-users/constants";

import { ADMIN_USERS_LIST_PATH } from "./admin-users/constants";
import {
  CLIENT_USERS_LIST_PATH,
  BUSINESS_USERS_LIST_PATH,
} from "./shared/appUserConstants";

export const getUserListPath = (userType: UserType = DEFAULT_USER_TYPE) => {
  if (userType === USER_TYPES.client.value) return CLIENT_USERS_LIST_PATH;
  if (userType === USER_TYPES.business.value) return BUSINESS_USERS_LIST_PATH;
  return ADMIN_USERS_LIST_PATH;
};

export const getUserViewPath = (
  userType: UserType,
  id: string | number
) => {
  if (userType === USER_TYPES.client.value) {
    return `${CLIENT_USERS_LIST_PATH}/view/${id}`;
  }
  if (userType === USER_TYPES.business.value) {
    return `${BUSINESS_USERS_LIST_PATH}/view/${id}`;
  }
  return `${ADMIN_USERS_LIST_PATH}/view/${id}`;
};

export const isAppUserType = (userType: UserType) =>
  userType === USER_TYPES.client.value || userType === USER_TYPES.business.value;

// Re-export status helpers for external consumers
export {
  ADMIN_USER_STATUS,
  ADMIN_USER_STATUS_BADGE,
  ADMIN_USER_STATUS_OPTIONS,
  isActiveAdminUser,
  getAdminUserToggleStatus,
} from "./admin-users/constants";
export {
  APP_USER_STATUS,
  APP_USER_STATUS_BADGE,
  APP_USER_STATUS_OPTIONS,
  isActiveAppUser,
  isBlockedAppUser,
  getAppUserToggleStatus,
} from "./shared/appUserConstants";
